import styled from '@emotion/styled';

const MenuStyled = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 auto;
  display: inline-block;
  position: relative;
  height: 100%;
`;

export default MenuStyled;
